/* eslint-disable no-unused-expressions */
/* eslint-disable import/prefer-default-export */
import { MisValesAhorroService } from '../../services';
import { BackMappings } from '../../utils/BackMappings';
import { GtmManager } from '../../utils/GtmManager';
import { SessionChecker } from '../../utils/SessionChecker';
import { MisDatosConstants } from '../../utils/MisDatosConstants';
import { FiltersConstants } from '../../utils/FiltersConstants';

export class ValesHelper {
  totalValesNoAct: number | any;

  totalValesAct: number | any;

  totalValesCanj: number | any;

  totalValesPreAct: number | any;

  lastValeNoActShownIndex: number | any;

  lastValeActShownIndex: number | any;

  lastValeCanjShownIndex: number | any;

  lastValePreActShownIndex: number | any;

  addError: any;

  addErrorBack: any;

  t: any;

  constructor(
    totalValesNoAct: number,
    totalValesAct: number,
    totalValesCanj: number,
    totalValesPreAct: number,
    t: any,
    addError: any,
    addErrorBack: any,
  ) {
    this.lastValeNoActShownIndex =
      FiltersConstants.NUM_CUPONES_MOSTRADOS_AL_INICIO - 1;
    this.lastValeActShownIndex =
      FiltersConstants.NUM_CUPONES_MOSTRADOS_AL_INICIO - 1;
    this.lastValeCanjShownIndex =
      FiltersConstants.NUM_CUPONES_MOSTRADOS_AL_INICIO - 1;
    this.lastValePreActShownIndex =
      FiltersConstants.NUM_CUPONES_MOSTRADOS_AL_INICIO - 1;
    this.totalValesNoAct = totalValesNoAct;
    this.totalValesAct = totalValesAct;
    this.totalValesCanj = totalValesCanj;
    this.totalValesPreAct = totalValesPreAct;
    this.t = t;
    this.addError = addError;
    this.addErrorBack = addErrorBack;
  }

  handleVerMasClick = (e: any) => {
    e.preventDefault();
    let initial;
    let final;
    let max = 0;
    const tipoLista = Number.parseInt(e.target.id, 10);
    if (tipoLista === 1) {
      initial = this.lastValeNoActShownIndex + 1;
      max = this.totalValesNoAct;
    }
    if (tipoLista === 4) {
      initial = this.lastValePreActShownIndex + 1;
      max = this.totalValesPreAct;
    }
    if (tipoLista === 2) {
      initial = this.lastValeActShownIndex + 1;
      max = this.totalValesAct;
    }
    if (tipoLista === 3) {
      initial = this.lastValeCanjShownIndex + 1;
      max = this.totalValesCanj;
    }
    final = initial + FiltersConstants.NUM_CUPONES_BTN_VER_MAS;
    if (final > max) {
      final = max;
    }
    for (let x = initial; x < final; x += 1) {
      const datastring = `[data-valeindex ='${x}']`;
      const elemento = document.querySelector(
        `[data-tipolista='${tipoLista}']${datastring}`,
      );
      if (elemento) {
        elemento.classList.remove(FiltersConstants.SELECTOR_CUPONES_OCULTOS);
        elemento.classList.add(FiltersConstants.SELECTOR_CUPONES_VISIBLES);
      }
    }
    if (tipoLista === 1) {
      this.lastValeNoActShownIndex = final - 1;
      if (this.totalValesNoAct === final) {
        e.target.style.display = 'none';
      }
    }
    if (tipoLista === 4) {
      this.lastValePreActShownIndex = final - 1;
      if (this.totalValesPreAct === final) {
        e.target.style.display = 'none';
      }
    }
    if (tipoLista === 2) {
      this.lastValeActShownIndex = final - 1;
      if (this.totalValesAct === final) {
        e.target.style.display = 'none';
      }
    }
    if (tipoLista === 3) {
      this.lastValeCanjShownIndex = final - 1;
      if (this.totalValesCanj === final) {
        e.target.style.display = 'none';
      }
    }
  };

  handleActivarVale = async (
    vale: any,
    cargarVales: any,
    lang: string,
    dataUser: any,
    label: string,
  ) => {
    const responseCheckSession = await SessionChecker.checkSession(
      BackMappings.VALES,
      lang,
      dataUser.user.isApp === 'true',
      dataUser.user.isRecuerdame,
    );
    if (!responseCheckSession) {
      return;
    }

    const activarData = vale;
    activarData.fechaIniVigencia = null;
    activarData.fechaCanjeo = null;
    activarData.horaCanjeo = null;
    GtmManager.sendActivarValeGTM(
      vale.numOferta && vale.numOferta !== ''
        ? vale.numOferta
        : vale.grupoInternoActivacion,
    );
    MisValesAhorroService.activarVale(activarData)
      .then((response) => {
        if (response.data.error) {
          this.addError(this.t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
        } else {
          GtmManager.sendAComportamientoEvent(
            response.data.pojo.gtmLayer,
            label,
          );
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          const elements = document.querySelector(
            'div.detalle-container.visible',
          );
          if (elements) {
            elements.remove();
          }

          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          const activeElements = document.querySelector(
            '.bloque-vale__total.active',
          );
          if (activeElements) {
            activeElements.classList.remove('active');
          }
          // CAMBIO DE PREFERENCIA
          if (
            activarData.preferencia !==
            MisDatosConstants.EROSKI_PROMOCION_DIGITAL
          ) {
            const preferenciaData = {
              anteriorPreferencia: activarData.preferencia,
              preferencia: MisDatosConstants.CLIENTE_PROMOCION_DIGITAL,
              origen: MisDatosConstants.ORIGEN_ACTIVAR_CUPON,
            };
            MisValesAhorroService.updateValesPreferencia(preferenciaData)
              .then((resp) => {
                cargarVales();
                if (resp.data.error) {
                  this.t('nlr-vaya-algo-no-ha-ido-bien');
                }
              })
              .catch((e) => {
                console.log(e);
              });
          } else {
            cargarVales();
          }
        }
      })
      .catch((e) => {
        console.log(e);
        this.addError(this.t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
      });
  };
}
